import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Course, ReadCourseModel, CoursesQueryResponse, H5PCoursesQueryResponse, H5PCourseUserDatasQueryResponse, CourseOption} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const H5P_API_URL = process.env.REACT_APP_H5P_API_URL
const GET_COURSE_URL = `${API_URL}/course/getcourse`
const CREATE_COURSE_URL = `${API_URL}/course/addcourse`
const UPDATE_COURSE_URL = `${API_URL}/course/updatecourse`
const DELETE_COURSE_URL = `${API_URL}/course/deletecourse`
const UNPUBLISH_COURSE_URL = `${API_URL}/course/unpublishcourse`
const GET_COURSES_URL = `${API_URL}/course/getcourses`
const GET_COURSES_H5P_URL = `${H5P_API_URL}/h5p/byContent`
const GET_COURSES_USER_DATA_H5P_URL = `${H5P_API_URL}/h5p/contentUserDataByUserAndContent`
const READ_COURSE_URL = `${API_URL}/course/readcourse`
const GET_COURSE_OPTIONS_URL =`${API_URL}/course/getcourseoptions`

const getCourses = (query: string): Promise<CoursesQueryResponse> => {
  return axios
    .get(`${GET_COURSES_URL}?${query}`)
    .then((d: AxiosResponse<CoursesQueryResponse>) => d.data)
}

const getCourseOptions = (query: string): Promise<CourseOption[]> => {
    return axios
        .get(`${GET_COURSE_OPTIONS_URL}?${query}`)
        .then((d: AxiosResponse<CourseOption[]>) => d.data)
}

const getH5PCourses = (contentIds: string[] | undefined): Promise<H5PCoursesQueryResponse> => {
  var instance = axios.create();
  delete instance.defaults.headers.common['Authorization'];
  return instance
    .post(`${GET_COURSES_H5P_URL}`, { contentIds: contentIds},
    {
      headers: {
        'Content-Type': 'application/json',
         'CSRF-Token': JSON.parse(String(localStorage.getItem('OpraziH5PConfig'))).csrfToken ?? ''
      },
      withCredentials: true
    } 
    )
    .then((d: AxiosResponse<H5PCoursesQueryResponse>) => d.data)
}

const getH5PCourseUserData = (contentIds: string[] | undefined, userId: string, contextId: string): Promise<H5PCourseUserDatasQueryResponse> => {
  var instance = axios.create();
  delete instance.defaults.headers.common['Authorization'];
  return instance
    .post(`${GET_COURSES_USER_DATA_H5P_URL}`, { contentIds: contentIds, userId: userId, contextId : contextId},
    {
      headers: {
        'Content-Type': 'application/json',
        'CSRF-Token': JSON.parse(String(localStorage.getItem('OpraziH5PConfig'))).csrfToken ?? ''
      },
      withCredentials: true
    } 
    )
    .then((d: AxiosResponse<H5PCourseUserDatasQueryResponse>) => d.data)
}


const getCourseById = (id: ID): Promise<Course | undefined> => {
  return axios
    .get(`${GET_COURSE_URL}/${id}`)
    .then((response: AxiosResponse<Response<Course>>) => response.data)
    .then((response: Response<Course>) => response.data)
}

const createCourse = (course: Course): Promise<Course | undefined> => {
  return axios
    .post(CREATE_COURSE_URL, course)
    .then((response: AxiosResponse<Response<Course>>) => response.data)
    .then((response: Response<Course>) => response.data)
}

const updateCourse = (course: Course): Promise<Course | undefined> => {
  return axios
    .put(`${UPDATE_COURSE_URL}/${course.id}`, course)
    .then((response: AxiosResponse<Response<Course>>) => response.data)
    .then((response: Response<Course>) => response.data)
}

const readCourse = (readCourseModel: ReadCourseModel): Promise<Course | undefined> => {
  return axios
    .post(READ_COURSE_URL, readCourseModel)
    .then((response: AxiosResponse<Response<Course>>) => response.data)
    .then((response: Response<Course>) => response.data)
}

const deleteCourse = (courseId: ID): Promise<void> => {
  return axios.delete(`${DELETE_COURSE_URL}/${courseId}`).then(() => {})
}

const unpublishCourse = (course: Course): Promise<void> => {
  return axios.post(`${UNPUBLISH_COURSE_URL}/${course.id}`, course).then(() => {})
}

const deleteSelectedCourses = (courseIds: Array<ID>): Promise<void> => {
  const requests = courseIds.map((id) => axios.delete(`${DELETE_COURSE_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getCourses, getH5PCourses, getH5PCourseUserData, deleteCourse, unpublishCourse, deleteSelectedCourses, getCourseById, createCourse, readCourse, updateCourse,getCourseOptions}
